import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const IngenieurSystemeFerroviaire = () => {
  const ingenieurSystemFerroviaireProgram = [
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Rédaction de synthèse",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title:
        "Développer les exigences / Comprendre les besoins et spécifier le produit",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Gérer les exigences et les demandes de changements",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "MBSE",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Le transport ferroviaire et guidé",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "SYSML",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "TS 22163",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "EN 50128",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "EN 50126",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "EN 50129",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Présenter ses nouvelles compétences",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Projet final",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Ferroviaire"
      titleColor="#000000"
      title="Ingénieur Système Ferroviaire"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Ingénieur Système Ferroviaire, après une formation accélérée de 11
            semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/ferroviaire.png"
      program={ingenieurSystemFerroviaireProgram}
      formId="d84e0aa7-295d-44bf-9bb5-8b183eb59cbb"
    />
  );
};

export default IngenieurSystemeFerroviaire;
